interface Props extends React.PropsWithChildren {
  noMargin?: boolean;
}
export const CpFormItem: React.FC<Props> = ({ noMargin, children }) => {
  return <div className={`cp-form-item ${noMargin ? "cp-form-item-no-margin" : ""} flex flex-col`}>{children}</div>;
};
